import React, { Component } from 'react';
import {__} from './../Translator';

import Dropdown from './../components/Dropdown';
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";

import { roundNumber } from './../Helpers';
import AppStore from "../flux/AppStore";
import AppActions from "../flux/AppActions";
import PerforedIcon from './../img/perforated.svg';
import StandardIcon from './../img/standard.svg';

import './ModelPerforate.css'
import currencySymbol from '../utils/currencySymbol';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';

class ModelPerforate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customProduct: AppStore.getCustomProduct(),
      nextVisibile: false,
    };

    props.navigation.onBack(() => {
      props.navigation.navigate('modelSelection');
    });

    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
  }

  componentDidMount() {
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);

    this.onPerforateChange(this.state.customProduct.perforated);
  }

  componentWillUnmount() {
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
  }

  onCustomProductUpdate() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  onPerforateChange(perforated) {
    if (perforated !== null) {
      this.setState({nextVisibile:true});
    }

    AppActions.updateCustomProduct({
      perforated
    });
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}
          breadcrumb={['Homepage', 'Product', this.state.customProduct.product.name]}
        />

        <Footer navigation={this.props.navigation} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />
        <div className="main">
            <div className="row">
              <div className="col-lg-6 col-lg-offset-3 col-xs-8 col-xs-offset-2">

                <div className="main__hero">
                  <h1 className="hero__title">{__('Select leather perforation')}</h1>
                  <div className="hero__text">
                    <p>{__('Pick a perforated leather for maximum ventilation or standard for mild ventilation')} </p>
                  </div>
                </div>
                <Dropdown
                  className="dropdown--large"
                  title={__('Select leather perforation')}
                  options={[
                    { value: false, text: this.formatPerforatedPrice(__('Standard leather'), 0), svg: StandardIcon },
                    { value: true, text: this.formatPerforatedPrice(__('Perforated leather'), this.state.customProduct.product.perforated_price),  svg: PerforedIcon },
                  ]}
                  selected={this.state.customProduct.perforated}
                  onChange={perforated => this.onPerforateChange(perforated)}
                />

                {this.state.nextVisibile ? (
                  <div className="text-center">
                    <button className="btn btn-primary btn-xlg btn-next" onClick={() => this.props.navigation.navigate('modelColor')}>
                      {__('NEXT')}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
    );
  }

  formatPerforatedPrice(text, price) {
    return this.state.customProduct.product.perforated_price === 0 ? (
      <span>{__(text)}</span>
    ) : (
      <span>
        {__(text)} <small>{shouldShowPrice(CountryStore.getState()) ? roundNumber(price)+ " " + currencySymbol() : ""}</small>
      </span>
    );
  }
}

export default ModelPerforate;



// WEBPACK FOOTER //
// ./src/screens/ModelPerforate.js